import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Form, Button } from 'react-bootstrap';
import { toast } from "react-toastify";

import { updatePassword } from "../components/apis/APICalls";
import { getAccountWaveBalance, getAccountAssetBalance } from '../components/blockchain functions/BlockchainFunctions';
import { LoginContext } from "../context/LoginContext";
//icons
import logo from '../components/assets/logo.png';
import profile from '../components/assets/icons/profile-portfolio.svg';
import editPencil from '../components/assets/icons/edit-pencil.svg';
import waveSymbol from '../components/assets/icons/wave-symbol.png';

const MyProfile = () => {
    const [isEdit, setIsEdit] = useState(false);//editing credentials
    const [loading, setLoading] = useState(false);//Loading bar
    const [loginData, setLoginData] = useContext(LoginContext);

    const GetBalance = () => {
        const [walletBalanceWave, setWalletBalanceWave] = useState(0);
        const [walletBalanceAsset, setWalletBalanceAsset] = useState(0);

        useEffect(async () => {
            setWalletBalanceWave(await getAccountWaveBalance(loginData.walletAddress));
            setWalletBalanceAsset(await getAccountAssetBalance(loginData.walletAddress));
        }, []);

        return (
            <span>
                <img style={{ height: "2rem" }} src={logo} /> {walletBalanceAsset} PANDAS<br />
                <img style={{ height: "2rem" }} src={waveSymbol} /> {walletBalanceWave} Waves
            </span>
        );
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        if (event.target.userPassword.value != event.target.passwordText.value) {
            toast.error("Password not matched");
            return;
        }
        // console.log(event.target);
        var userObj = {
            email: event.target.userEmail.value,
            password: event.target.userPassword.value
        }
        console.log(userObj.email, userObj.password);
        // update credentials api call
        let result = await updatePassword(userObj);
        console.log(result);
        if (result.success)
            toast.success("Password updated successfully");
        else
            toast.error("Password updated failed");
        setIsEdit(false);
    }


    return (
        <>
            <div className="page-heading">
                <h2><img style={{ height: "3rem" }} src={profile} /> My Profile</h2>
                <span>Here you can view your profile</span>
            </div>
            <hr />

            <div className="view-profile">
                {isEdit ?
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col sm={4}>
                                <Form.Label>Email</Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Group className="mb-8" controlId="email">
                                    <Form.Control type="email" id="userEmail" defaultValue={loginData?.email} disabled={true} required />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <Form.Label>Password (visible as text)</Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Group className="mb-8" controlId="passwordText">
                                    <Form.Control type="text" id="passwordText" defaultValue="" required />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <Form.Label>Password</Form.Label>
                            </Col>
                            <Col sm={8}>
                                <Form.Group className="mb-8" controlId="Password">
                                    <Form.Control type="password" id="userPassword" required />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Button variant="primary" type="submit" style={{ width: "100%" }}>
                                    Submit
                                </Button>
                            </Col>
                            <Col sm={6}>
                                <Button variant="secondary" style={{ width: "100%" }} onClick={() => setIsEdit(false)}>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    : <>
                        <Button className="float-right" variant="outline-warning" onClick={() => setIsEdit(true)}
                            disabled={loginData==null||loginData?.phrase==""}>
                            <img style={{ height: "1.5rem" }} src={editPencil} /> Update Password
                        </Button>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <span className="text-heading fw-bold">Email : </span>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div>
                                    <span className="amount" id="emailValue">{loginData==null?"-":loginData?.email}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <span className="text-heading fw-bold">Wallet Address : </span>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div>
                                    <span className="amount" style={{wordBreak:"break-all"}} id="walletAddress">{loginData==null?"-":loginData?.walletAddress}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <span className="text-heading fw-bold">Available Balance : </span>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div>
                                    <span className="amount" id="balanceValue" > <GetBalance /> </span>
                                </div>
                            </Col>
                        </Row>
                    </>}
            </div>
            <br/><br/><br/><br/>
        </>
    )
}

export default MyProfile